module.exports = __webpack_public_path__ + "img/optical-disc.f945bbc5.png";